import { Separator } from "@/components/ui/separator";
import Header from "./components/header";
import Transactions from "./components/transactions";
import { useTranslation } from "react-i18next";
import Tasks from "./components/tasks";

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <title>{t("title.today")}</title>
      <Header />
      <Separator className="my-5" />
      <Transactions />
      <Tasks />
    </>
  );
};

export default Home;
